import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { API_BASE } from '../lib/config';

const API = API_BASE;

const AdminSettingsFees = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [platformFeeRate, setPlatformFeeRate] = useState('0.18');
  const [withdrawalFee, setWithdrawalFee] = useState('200');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user || user.user_type !== 'admin') {
      toast.error('管理者権限が必要です');
      navigate('/');
      return;
    }
    (async () => {
      try {
        const res = await fetch(`${API}/admin/settings`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
        if (res.ok) {
          const data = await res.json();
          // Handle both Object and List formats for compatibility
          const map = {};
          if (Array.isArray(data)) {
            data.forEach(item => map[item.key] = item.value);
          } else {
            Object.assign(map, data);
          }
          setPlatformFeeRate(String(map.platform_fee_rate ?? '0.18'));
          setWithdrawalFee(String(map.withdrawal_fee ?? '200'));
        }
      } catch { }
    })();
  }, [user, navigate]);

  const save = async () => {
    try {
      setLoading(true);
      const headers = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` };

      // Use correct PUT /settings/{key} endpoint
      let res = await fetch(`${API}/admin/settings/platform_fee_rate`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({ value: parseFloat(platformFeeRate) })
      });
      if (!res.ok) throw new Error('運営手数料率の更新に失敗しました');

      res = await fetch(`${API}/admin/settings/withdrawal_fee`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({ value: parseInt(withdrawalFee, 10) })
      });
      if (!res.ok) throw new Error('引き出し手数料の更新に失敗しました');

      toast.success('保存しました');
    } catch (e) {
      toast.error(e.message || '保存に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8 max-w-3xl">
        <div className="mb-6 flex items-center">
          <button onClick={() => navigate('/admin')} className="text-gray-600 hover:text-gray-900 mr-3">← 管理ダッシュボードに戻る</button>
          <h1 className="text-2xl font-bold">料金設定</h1>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">運営手数料率（小数, 例: 0.17）</label>
          <input type="number" step="0.01" value={platformFeeRate} onChange={(e) => setPlatformFeeRate(e.target.value)} className="w-full px-3 py-2 border rounded mb-4" />
          <label className="block text-sm font-medium text-gray-700 mb-1">求職者 引き出し手数料（円）</label>
          <input type="number" value={withdrawalFee} onChange={(e) => setWithdrawalFee(e.target.value)} className="w-full px-3 py-2 border rounded mb-6" />
          <button onClick={save} disabled={loading} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50">{loading ? '保存中...' : '保存'}</button>
        </div>
      </div>
    </div>
  );
};

export default AdminSettingsFees;
